import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Send, Mail, FileText, MessageSquare, Loader2 } from "lucide-react";
import { toast } from "sonner";

const ICON_BY_TIPO = {
  email: Mail,
  whatsapp: MessageSquare,
  nota: FileText,
  sistema: FileText,
};

const fmtData = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }); } catch { return iso; }
};

export default function ConversasLead({ leadId }) {
  const [items, setItems] = useState([]);
  const [nota, setNota] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const { data } = await api.get(`/comercial/leads/${leadId}/conversas`);
    setItems(data.items || []);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [leadId]);

  const enviarNota = async () => {
    if (!nota.trim()) return;
    setBusy(true);
    try {
      await api.post(`/comercial/leads/${leadId}/nota`, { conteudo: nota });
      toast.success("Nota adicionada");
      setNota("");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Falha"); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-4" data-testid="conversas-lead">
      <Card className="p-4">
        <Label className="text-sm font-bold mb-2 block" style={{ color: "#1B3A6B" }}>Adicionar nota interna</Label>
        <Textarea
          value={nota}
          onChange={(e) => setNota(e.target.value)}
          placeholder="Ex: Cliente pediu desconto de 10%. Vou apresentar proposta revisada amanhã."
          data-testid="nota-input"
          rows={2}
        />
        <Button onClick={enviarNota} disabled={busy || !nota.trim()} className="mt-2 text-white" style={{ background: "#1B3A6B" }} data-testid="nota-enviar">
          {busy ? <Loader2 size={14} className="animate-spin mr-2" /> : <Send size={14} className="mr-2" />} Adicionar
        </Button>
      </Card>

      {items.length === 0 ? (
        <Card className="p-6 text-center text-sm text-muted-foreground">Nenhuma comunicação ainda.</Card>
      ) : (
        <div className="space-y-2">
          {items.map((c) => {
            const Icon = ICON_BY_TIPO[c.tipo] || FileText;
            const isCliente = c.direcao === "entrada";
            return (
              <Card key={c.id} className={`p-3 ${isCliente ? "border-l-4 border-l-green-500 bg-green-50/40" : ""}`} data-testid={`conv-${c.id}`}>
                <div className="flex items-start gap-3">
                  <Icon size={20} style={{ color: isCliente ? "#16a34a" : "#1B3A6B" }} className="flex-shrink-0 mt-0.5" />
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2 mb-1">
                      <div className="text-sm">
                        <strong>{c.autor_nome || "Sistema"}</strong>
                        <span className="text-xs text-muted-foreground ml-2 uppercase">
                          {c.tipo} · {isCliente ? "↩ recebida" : "↗ enviada"}
                        </span>
                      </div>
                      <span className="text-xs text-muted-foreground">{fmtData(c.criado_em)}</span>
                    </div>
                    {c.assunto && <div className="text-sm font-medium">{c.assunto}</div>}
                    {c.destinatario && <div className="text-xs text-muted-foreground">→ {c.destinatario}</div>}
                    <div className="text-sm mt-1 whitespace-pre-wrap">{c.conteudo}</div>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
